import classNames from 'classnames';
import React from 'react';

import appStore from 'client/AppStore';
import albeyWaving from 'client/assets/characters/Albey/albey_poses_Waving.svg';
import {history} from 'client/history';
import JoinClassroomForm from 'client/Classrooms/JoinClassroom/JoinClassroomForm';
import JoinClassroomInput from 'client/Classrooms/JoinClassroom/JoinClassroomInput';
import JoinClassroomSubmitButton from 'client/Classrooms/JoinClassroom/JoinClassroomSubmitButton';
import {Text} from '@albert-io/atomic';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

const ALBEY_SIZE_MOBILE = 75;
const ALBEY_SIZE_DESKTOP = 175;

export default function Welcome() {
  const isMobile = appStore.isMobileView();

  const setShouldReloadStudent = useStudentDashboard((state) => state.setShouldReloadStudent);
  const showJoinClassModal = useStudentDashboard((state) => state.showJoinClassModal);
  function onEnrollSuccess() {
    history.replace('/home/assignments');
    setShouldReloadStudent(true);
  }

  return (
    <div
      className={classNames('flex items-center justify-center gap-x14', {
        'flex-col': isMobile,
        'h-full': !isMobile
      })}
    >
      <div className='w-[250px]'>
        <Text className='mb-x3 block font-black' size='xl'>
          Welcome to Albert!
        </Text>
        <JoinClassroomForm isNewStudentDashboard onEnrollSuccess={onEnrollSuccess}>
          <JoinClassroomInput className='mb-x1-half' hideLabel inert={showJoinClassModal} />
          <JoinClassroomSubmitButton className='w-full rounded-full' inert={showJoinClassModal} />
        </JoinClassroomForm>
      </div>
      <img
        alt='Illustration of Albey waving'
        src={albeyWaving}
        width={isMobile ? ALBEY_SIZE_MOBILE : ALBEY_SIZE_DESKTOP}
      />
    </div>
  );
}
